module.exports = __webpack_public_path__ + "img/building-1.de9eb98c.png";